import React, { useState, useEffect } from 'react';
import {
  CountCell,
  useNotification,
  getDialogHeading,
  showBackdropLoader,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import Dialog from '@mui/material/Dialog';
import {
  getAdminViewLinkUsers,
  getAdminUnViewLinkUsers,
} from 'layouts/userLinks/services/linksApi';
import { MassBox } from 'components/Ui/styled';
import { useSelector, useDispatch } from 'react-redux';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import EngagementMetricsDialog from './EngagementMetricsDialog';
import { intialPageSize, PaperPropsWithoutScrollbar } from 'constants';
import { setViewUnviewUsers } from 'layouts/userLinks/store/adminLinksSlice/adminLinksSlice';

const ViewLinkEngagementDialog = (props) => {
  const { open, setOpen, isFormLoading, setIsFormLoading } = props;
  const { NotificationPopup, handleErrorResponse } = useNotification();
  const dispatch = useDispatch();

  const [openEngagementMetricsDialog, setOpenEngagementMetricsDialog] =
    useState(false);
  const [viewLinkEngagement, setViewLinkEngagement] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
  });

  const { page, pageSize } = viewLinkEngagement;

  const viewEngagementLists = useSelector(
    (state) => state?.adminLinks?.viewEngagementLists || {}
  );

  useEffect(() => {
    if (viewEngagementLists?.trainingLink) {
      setViewLinkEngagement((prev) => ({
        ...prev,
        rows: [
          {
            id: viewEngagementLists?.trainingLink?.id,
            name: viewEngagementLists?.trainingLink?.name,
            description: viewEngagementLists?.trainingLink?.description,
            url: viewEngagementLists?.trainingLink?.url,
            totalUsers: viewEngagementLists?.totalUsers,
            viewedCount: viewEngagementLists?.viewedCount,
            unviewedCount: viewEngagementLists?.unviewedCount,
          },
        ],
      }));
    }
  }, [viewEngagementLists, page, pageSize]);

  const handleViewUnviewUser = async (params) => {
    try {
      const field = params?.field;
      const { id } = params?.row;

      setIsFormLoading(true);
      const callApi = () =>
        field === 'viewedCount'
          ? getAdminViewLinkUsers(id)
          : getAdminUnViewLinkUsers(id);

      const data = await callApi();
      dispatch(setViewUnviewUsers(data));
      setIsFormLoading(false);
      setOpenEngagementMetricsDialog(true);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const columns = [
    {
      headerName: 'Name',
      field: 'name',
      flex: 1,
    },
    {
      headerName: 'Total Users',
      field: 'totalUsers',
      flex: 1,
      align: 'center',
    },
    {
      headerName: 'Viewed Count',
      field: 'viewedCount',
      flex: 1,
      align: 'center',
      renderCell: (params) => (
        <CountCell params={params} onClick={handleViewUnviewUser} />
      ),
    },
    {
      headerName: 'Unviewed Count',
      field: 'unviewedCount',
      flex: 1,
      align: 'center',
      renderCell: (params) => (
        <CountCell params={params} onClick={handleViewUnviewUser} />
      ),
    },
  ];

  const pageSizeChange = pageSizeChangeHandler(setViewLinkEngagement);

  const handleClose = (event, reason) => {
    if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={PaperPropsWithoutScrollbar}
      >
        {showBackdropLoader(isFormLoading)}
        {getDialogHeading('Engagement', handleClose)}
        <MassBox>
          <DeltaDataGrid
            columns={columns}
            setListData={pageSizeChange}
            listData={viewLinkEngagement}
          />
          <EngagementMetricsDialog
            open={openEngagementMetricsDialog}
            setOpen={setOpenEngagementMetricsDialog}
          />
          <NotificationPopup />
        </MassBox>
      </Dialog>
    </>
  );
};

export default ViewLinkEngagementDialog;
